module.exports = __webpack_public_path__ + "static/img/6.2de17b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/6.jpg
// module id = bPJ5
// module chunks = 18